module.exports = __webpack_public_path__ + "img/header.eaeb633d.png";